import {
    FINISHED_GETTING_PATIENT_INFO,
    FINISHED_CONFIRMING_POSTAL_CODE,
    RETURN_TO_INTRODUCTION_SCREEN,
    START_APPLICATION_AFTER_SETTING_UP_ADMIN_OPTIONS,
    CANCEL_POSTAL_CODE_CONFIRMATION,
    SUBMIT_HEALTH_CARD_NUMBER_TO_SERVER
} from "./constant";
import { ActionCreator } from "redux";
import {
    FinishedPostalCodeConfirmationAction,
    FinishedGettingPatientDataFromServerAction,
    ReturnToIntroductionScreenAction,
    StartApplicationAfterSettingAdminOptionsAction,
    CancelPostalCodeConfirmationAction,
    SubmitHealthCardNumberToServerAction,
    StartApplicationPayload
} from "./types";
import { PatientIndividualInformationDto, HealthCardAcquisitionType } from "../../dtos/KioskDtos.dtos";

export const finishedGettingPatientDataFromServer: ActionCreator<FinishedGettingPatientDataFromServerAction> = (
    patientData: PatientIndividualInformationDto
) => ({
    type: FINISHED_GETTING_PATIENT_INFO,
    payload: {
        patientData
    }
});

export const finishedPostalCodeConfirmation: ActionCreator<FinishedPostalCodeConfirmationAction> = () => ({
    type: FINISHED_CONFIRMING_POSTAL_CODE
});

export const returnToIntroductionScreen: ActionCreator<ReturnToIntroductionScreenAction> = () => ({
    type: RETURN_TO_INTRODUCTION_SCREEN
});

export const startApplicationAfterSettingAdminOptions: ActionCreator<StartApplicationAfterSettingAdminOptionsAction> = (
    payload: StartApplicationPayload
) => ({
    type: START_APPLICATION_AFTER_SETTING_UP_ADMIN_OPTIONS,
    payload
});

export const cancelPostalCodeConfirmation: ActionCreator<CancelPostalCodeConfirmationAction> = () => ({
    type: CANCEL_POSTAL_CODE_CONFIRMATION
});

export const submitHealthCardNumberToServer: ActionCreator<SubmitHealthCardNumberToServerAction> = (
    healthCardNumber: string,
    acquisitionType: HealthCardAcquisitionType
) => ({
    type: SUBMIT_HEALTH_CARD_NUMBER_TO_SERVER,
    payload: {
        healthCardNumber,
        acquisitionType
    }
});


// WEBPACK FOOTER //
// ./src/sagas/ApplicationAsyncSagas/actions.ts